import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SE_UI_DATE_FORMATS, SeDatetimePickerComponent, SeTimePickerComponent } from '@se/platform';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { DateCellEditorBaseComponent } from '../date-cell-editor-base/date-cell-editor-base.component';

/**
 * Inline DateTime/Date/Time Input Custom Editor
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-date-cell-editor-inline',
    templateUrl: './date-cell-editor-inline.component.html',
    styleUrls: ['./date-cell-editor-inline.component.scss'],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: SE_UI_DATE_FORMATS }],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        SeDatetimePickerComponent,
        SeTimePickerComponent,
        FocusSelectOnDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateCellEditorInlineComponent extends DateCellEditorBaseComponent {}
